import React from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import CheckIcon from '@repo/ui/components/Icon/CheckIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { H2, P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { defaultVariant } from './config';
import { Benefit, BackgroundImage, Wrapper, Content } from './styles';

const RightColumn: React.FC = () => {
  const { title, benefits, content, background, fullWidthBackground } =
    defaultVariant;
  return (
    <Wrapper>
      <Content>
        <H2 color={themeStyle.inkBase}>{title}</H2>
        <Spacer height="48px" />
        <FlexColumn height="100%" justifyContent="space-between">
          <div>
            {benefits?.map((benefit, index) => (
              <Benefit key={index}>
                <CheckIcon
                  height="18px"
                  theme={{ color: themeStyle.blueMain }}
                />
                <Spacer width="10px" />
                <P2 color={themeStyle.inkBase}>{benefit}</P2>
              </Benefit>
            ))}
            {content}
          </div>
          <BackgroundImage fullWidth={!!fullWidthBackground} src={background} />
        </FlexColumn>
      </Content>
    </Wrapper>
  );
};

export default RightColumn;
